import { Grid, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import React, { Fragment, useCallback, useRef } from 'react';
import * as yup from 'yup';
import SweetAlert from '../../../../Components/Alerts/SweetAlert';
import FileInput from '../../../../Components/Inputs/FileInput';
import FileGridList from '../../../../Components/Inputs/File/FileGridList';
import { VALID_FILE_EXTENSIONS } from '../../Pqr_enums';
import clsx from 'clsx';
import { convertBytesToMegaBytes } from '../../../../Utils/Calculations/file';
import { maxMBSizePqrFiles } from '../../../../Configs/general';

const fileSchema = yup.array().of(
  yup.object({
    size: yup
      .number()
      // eslint-disable-next-line no-template-curly-in-string
      .test('fileSize', '${path}->Tamaño máximo: 10 MB', value => {
        return value <= 10240000;
      }),
    name: yup.string(),
    type: yup.string(),
    extension: yup
      .string()
      // eslint-disable-next-line no-template-curly-in-string
      .test('extension', '${path}->Archivo no permitido', extension =>
        VALID_FILE_EXTENSIONS.includes(extension)
      ),
    file: yup.mixed()
  })
);

const parseFiles = (currentFiles, incomingFiles) => {
  const preparedFiles = incomingFiles.map(file => {
    const { name, size, type } = file;

    const extension = name
      .split('.')
      .pop()
      .toLowerCase();

    return { name, size, type, extension, file, error: false };
  });

  const parsedFiles = currentFiles.slice();

  for (let i = 0; i < preparedFiles.length; ++i) {
    let found = false;
    for (let j = 0; j < currentFiles.length; ++j) {
      if (currentFiles[j].name === preparedFiles[i].name) {
        parsedFiles[i] = currentFiles[j];
        found = true;
        break;
      }
    }

    if (!found) {
      parsedFiles.push(preparedFiles[i]);
    }
  }

  try {
    fileSchema.validateSync(parsedFiles, {
      abortEarly: false
    });
  } catch (err) {
    for (const errorMessage of err.errors) {
      const [identifier, message] = errorMessage.split('->');
      const index = identifier.split('.')[0];

      const idx = parseInt(index.substr(1, index.length - 1), 10);

      parsedFiles[idx].error = true;
      parsedFiles[idx].errorMessage = message;
    }
  }

  const sortedParsedFiles = parsedFiles.slice();

  sortedParsedFiles.sort((a, b) => b.error - a.error);

  return sortedParsedFiles;
};

const DefaultAttachmentSection = ({
  classes,
  fileInputId,
  files,
  setFiles,
  totalSize,
  setTotalSize
}) => {
  const theme = useTheme();
  const isMobileSize = useMediaQuery(theme.breakpoints.down('xs'));
  const fileInputRef = useRef(null);

  const handleDeleteFile = useCallback(
    fileIndex => {
      const filteredFiles = files.filter((_file, index) => index !== fileIndex);

      const totalFilesSize = filteredFiles.reduce(
        (total, file) => total + file.size,
        0
      );

      setFiles(filteredFiles);
      setTotalSize(convertBytesToMegaBytes(totalFilesSize));
      fileInputRef.current.value = '';
    },
    [files, fileInputRef, setFiles, setTotalSize]
  );

  const handleChangeFile = useCallback(
    e => {
      const inputFiles = Array.from(e.target.files);

      const parsedFiles = parseFiles(files, inputFiles);

      const totalFilesSize = parsedFiles.reduce(
        (total, file) => total + file.size,
        0
      );

      setFiles(parsedFiles);
      setTotalSize(convertBytesToMegaBytes(totalFilesSize));
    },
    [files, setFiles, setTotalSize]
  );
  return (
    <Fragment>
      <Grid item xs={12}>
        <Typography className={classes.title}>Anexos (Opcional)</Typography>
      </Grid>

      <Grid item sm="auto" xs={12} className={classes.inputContainerItem}>
        <FileInput
          id={fileInputId}
          ref={fileInputRef}
          name="attachments"
          accept={VALID_FILE_EXTENSIONS.map(ext => `.${ext}`).join(',')}
          text="Adjuntar archivos"
          inputProps={{
            onChange: handleChangeFile
          }}
          helperText={
            <span className={classes.noWrap}>{totalSize} MB/50 MB</span>
          }
          error={totalSize > maxMBSizePqrFiles}
          disabled={totalSize > maxMBSizePqrFiles}
          buttonProps={{
            color: 'default'
          }}
          multiple
          iconVisible
        />
      </Grid>
      <Grid
        item
        sm="auto"
        xs={12}
        className={clsx(
          classes.inputContainerItem,
          classes.sweetAlertContainer
        )}
      >
        <SweetAlert
          id="Pqr_Contact_alert"
          type="info"
          noIcon={isMobileSize}
          message={
            <Fragment>
              Archivos permitidos:{' '}
              {VALID_FILE_EXTENSIONS.map(ext => ` .${ext}`)}
            </Fragment>
          }
          classes={{
            root: classes.sweetAlert,
            message: classes.sweetAlertText
          }}
        />
      </Grid>
      {files && files.length > 0 && (
        <FileGridList
          id="Pqr_detail_filelist"
          files={files}
          onDeleteFile={handleDeleteFile}
          className={clsx(classes.inputContainerItem, classes.filelistItem)}
        />
      )}
    </Fragment>
  );
};

export default DefaultAttachmentSection;
